/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ location: NonNullable<unknown> }} Experience_Location_RemoteInputs */

const en_experience_location_remote = /** @type {(inputs: Experience_Location_RemoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.location} (Remote)`)
};

const ar_experience_location_remote = /** @type {(inputs: Experience_Location_RemoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.location} (عن بُعد)`)
};

const bn_experience_location_remote = /** @type {(inputs: Experience_Location_RemoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.location} (রিমোট)`)
};

const de_experience_location_remote = /** @type {(inputs: Experience_Location_RemoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.location} (Remote)`)
};

const es_experience_location_remote = /** @type {(inputs: Experience_Location_RemoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.location} (Remoto)`)
};

const fr_experience_location_remote = /** @type {(inputs: Experience_Location_RemoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.location} (à distance)`)
};

const pt_experience_location_remote = /** @type {(inputs: Experience_Location_RemoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.location} (remoto)`)
};

const zh_experience_location_remote = /** @type {(inputs: Experience_Location_RemoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.location}（远程）`)
};

const tr_experience_location_remote = /** @type {(inputs: Experience_Location_RemoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.location} (Uzak)`)
};

const ru_experience_location_remote = /** @type {(inputs: Experience_Location_RemoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.location} (удаленно)`)
};

const pl_experience_location_remote = /** @type {(inputs: Experience_Location_RemoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.location} (zdalnie)`)
};

/**
* | output |
* | --- |
* | "{location} (Remote)" |
*
* @param {Experience_Location_RemoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const experience_location_remote = /** @type {((inputs: Experience_Location_RemoteInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_Location_RemoteInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_experience_location_remote(inputs)
	if (locale === "bn") return bn_experience_location_remote(inputs)
	if (locale === "de") return de_experience_location_remote(inputs)
	if (locale === "es") return es_experience_location_remote(inputs)
	if (locale === "fr") return fr_experience_location_remote(inputs)
	if (locale === "pt") return pt_experience_location_remote(inputs)
	if (locale === "zh") return zh_experience_location_remote(inputs)
	if (locale === "tr") return tr_experience_location_remote(inputs)
	if (locale === "ru") return ru_experience_location_remote(inputs)
	if (locale === "pl") return pl_experience_location_remote(inputs)
	return en_experience_location_remote(inputs)
});